import { catchError } from 'rxjs/operators';
import { Observable, Subject, throwError } from 'rxjs';
import { Injectable } from '@angular/core';

import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from '@angular/common/http';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PairingStepFormApi {

  error = new Subject<string>();

  constructor(private http: HttpClient) { }

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json;',
    }),
  };

  requestOptions: Object = {
    'Content-Type': 'application/json',
    responseType: 'blob',
    observe: 'response',
  };

  getRegions(userId: any, selectedProductLine: any = [], selectedBusinessLine: any = []) {
    let bLine = selectedBusinessLine.length < 1 ? null : selectedBusinessLine[0];
    let pLine = selectedProductLine.length < 1 ? null : selectedProductLine[0];
    return this.http.post<any>(
      `${environment.apiUrl}/v1/regions?userId=${userId}&businessLine=${bLine}&productLine=${pLine}`
      , {});
  }

  getCountrys(regionId: number) {
    return this.http.post<any>(
      `${environment.apiUrl}/v1/countries`,
      { regionId },
      {}
    );
  }

  getCountrysByRegionCode(regionCode: any) {
    return this.http.post<any>(
      `${environment.apiUrl}/v1/countriesByCode`,
      { regionCode },
      {}
    );
  }

  getBusinessLines(region: any, productLines: any = [], userId: any) {
    let pLine = productLines.length < 1 ? null : productLines[0];
    return this.http.post<any>(`${environment.apiUrl}/v1/businessLines?userId=${userId}&productLines=${pLine}&regionCode=${region}`, null);
  }

  getProductLines(region: any, userId: any, businessLines: any = []) {
    let bLine = businessLines.length < 1 ? null : businessLines[0];
    return this.http.post<any>(`${environment.apiUrl}/v1/productlines?userId=${userId}&businessLine=${bLine}&regionCode=${region}`, null);
  }

  getMichelinBrands(plCode: any = []) {
    console.log('plCode', plCode);
    let pl = plCode.length < 1 ? null : plCode.join(',');
    return this.http.post<any>(
      `${environment.apiUrl}/v1/brands?type=michelin&isMichelinExcluded=false&productLineCodes=${pl}`,
      null
    );
  }

  getSubSeasons(brandIds: any, productLineCodes: any = []) {
    return this.http.post<any>(
      `${environment.apiUrl}/v1/subSeasons`,
      {
        brandIds, productLineCodes,
      },
      {}
    );
  }

  getOtherSubSeasons(brandIds: any, productLineCodes: any = []) {
    return this.http.post<any>(
      `${environment.apiUrl}/v1/subSeasons/y`,
      {
        brandIds, productLineCodes,
      },
      {}
    );
  }

  getTyreUsage(brandIds: any, subSeasonIds: any, productLineCodes: any = []) {
    return this.http.post<any>(
      `${environment.apiUrl}/v1/usage`,
      { brandIds, subSeasonIds, productLineCodes },
      {}
    );
  }

  getOtherTyreUsage(brandIds: any, subSeasonIds: any, productLineCodes: any = []) {
    return this.http.post<any>(
      `${environment.apiUrl}/v1/usage/y`,
      { brandIds, subSeasonIds, productLineCodes },
      {}
    );
  }

  getMichelinTyreLines(brandIds: any, subSeasonIds: any, usageIds: any, productLineCodes: any = []) {
    let type = 'Michelin';
    return this.http.post<any>(
      `${environment.apiUrl}/v1/tirelines/x`,
      { brandIds, subSeasonIds, usageIds, productLineCodes, type },
      {}
    );
  }

  getOtherTyreLines(brandIds: any, subSeasonIds: any, usageIds: any, productLineCodes: any = [], type: string) {
    return this.http.post<any>(
      `${environment.apiUrl}/v1/tirelines/y`,
      { brandIds, subSeasonIds, usageIds, productLineCodes, type },
      {});
  }

  getOtherBrands(isMichelinExcluded: boolean, plCode: any = []) {
    let pl = plCode.length < 1 ? null : plCode.join(',');
    return this.http.post<any>(
      `${environment.apiUrl}/v1/brands?type=competitor&isMichelinExcluded=${isMichelinExcluded}&productLineCodes=${pl}`,
      null
    );
  }



  getClusteringValues(
    regionId: number,
    parameterType: string,
    productLineCodes: any = []
  ) {
    return this.http.post<any>(
      `${environment.apiUrl}/v1/parameters`,
      { regionId, parameterType, productLineCodes },
      {}
    );
  }

  getDegradationFile(
    userId: any,
    clustering: any,
    degradation: any,
    regionId: number,
    productLineCodes: any = []
  ) {

    const headers = new HttpHeaders({
      userId: userId.toString(),
    });


    return this.http.post<any>(
      `${environment.apiUrl}/v1/download/degradation-rule-sheet`,
      { clustering, degradation, regionId, productLineCodes },
      { headers: headers, ...this.requestOptions }
    );
  }

  uploadDegradationFile(formData: any, userId: string) {

    const headers = new HttpHeaders({
      userId: userId.toString(),
    });

    return this.http
      .post<any>(
        `${environment.apiUrl}/v1/upload/degradation-rule-sheet`,
        formData,
        { headers: headers }
      )
      .pipe(catchError(this.errorHandler));
  }

  getCompetitorFile(formData: any, userId: string) {
    const headers = new HttpHeaders({
      userId: userId.toString(),
    });
    return this.http.post<any>(
      `${environment.apiUrl}/v1/download/competitor-priority`,
      formData,
      { headers: headers, ...this.requestOptions }
    );
  }

  getCAIFile(userId: string, isMultiplePL: boolean) {
    const headers = new HttpHeaders({
      userId: userId.toString(),
      isMultiplePL: isMultiplePL.toString()
    });
    return this.http.post<any>(
      `${environment.apiUrl}/v1/download/cai-list`,
      null,
      { headers: headers, ...this.requestOptions }
    );
  }

  getPriceFXFile(formData: any) {
    return this.http.post<any>(
      `${environment.apiUrl}/v1/download/downloadPriceFX`,
      formData,
      this.requestOptions
    );
  }

  getMissingCAIFile(file: any) {

    return this.http
      .post<any>(
        `${environment.apiUrl}/v1/downloadMissingCAI?file=${file}`,
        {},
        this.requestOptions
      )
      .pipe(catchError(this.errorHandler));
  }

  uploadCompetitorFile(formData: any, userId: string) {
    const headers = new HttpHeaders({
      userId: userId.toString(),
    });

    return this.http
      .post<any>(
        `${environment.apiUrl}/v1/upload/competitor-priority`,
        formData,
        {
          headers: headers,
        }
      )
      .pipe(catchError(this.errorHandler));
  }

  uploadCAIFile(formData: any) {
    const requestOptions: Object = {
      'Content-Type': 'application/json',
      observe: 'response',
    };

    return this.http
      .post<any>(
        `${environment.apiUrl}/v1/upload/cai`,
        formData,
        requestOptions
      )
      .pipe(catchError(this.errorHandler));
  }

  getDraftRecord(requestId: any) {
    if (null == sessionStorage.getItem('parentToken')) {
      return this.http.get(`${environment.apiUrl}/v1/jobrequests/${requestId}`);
    } else {
      const token = sessionStorage.getItem('parentToken').replace('token=', '');
      let headers: HttpHeaders = new HttpHeaders();
      headers = headers.append('Content-Type', 'application/json');
      headers = headers.append('parentToken', token);
      const formData = {
        authId: sessionStorage.getItem('id'),
        requestId: 'Pairing-' + requestId
      };
      return this.http
        .post<any>(`${environment.apiUrl}/v1/fetchRequest`, formData, {
          headers: headers,
        })
        .pipe(catchError(this.errorHandler));
    }
  }

  onSubmit(formData: any, userId: string): Observable<any> {
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    headers = headers.append('responseType', 'text');
    headers = headers.append('userId', userId.toString());

    return this.http
      .post<any>(`${environment.apiUrl}/v1/submit`, formData, {
        headers: headers,
      })
      .pipe(catchError(this.errorHandler));
  }

  onSaveDraft(formData: any, userId: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      responseType: 'text',
      userId: userId.toString(),
    });

    return this.http
      .post<any>(`${environment.apiUrl}/v1/saveDraft`, formData, {
        headers: headers,
      })
      .pipe(catchError(this.errorHandler));
  }

  errorHandler(error: HttpErrorResponse) {
    return throwError(error);
  }

  getTirelinesValues(
    brandName: string,
    productLineCode: any = [],
    brandType: string
  ) {
    let plCode = productLineCode.length < 1 ? null : productLineCode[0];
    return this.http.post<any>(
      `${environment.apiUrl}/v1/tireLinesByBrandName?brandName=${brandName}&productLineCodes=${plCode}&brandType=${brandType}`,
      {}
    );
  }

  getBrandTirelinesValues(brandDetails: any) {
    return this.http.post<any>(
      `${environment.apiUrl}/v1/brandTirelines`,
      brandDetails
    );
  }

  getUser() {
    const headers = new HttpHeaders({
      authId: sessionStorage.getItem('id'),
      parentToken: sessionStorage.getItem('parentToken') ? sessionStorage.getItem('parentToken').replace('token=', '') : '',
      'Content-Type': 'application/json',
    });
    return this.http.post<any>(`${environment.apiUrl}/v1/user`, null, {
      headers: headers,
    });
  }

  getWebsites(pricePeriodStart: any, pricePeriodEnd: any, regionCode: any, country: any) {
    const formData = {
      pricePeriodStart: pricePeriodStart,
      pricePeriodEnd: pricePeriodEnd,
      regionCode: regionCode,
      country: country
    };
    return this.http.post<any>(`${environment.apiUrl}/v1/fetchWebsites`, formData)
      .pipe(catchError(this.errorHandler));
  }

  getCompPrioDetailsFromFile(fileName: string, productLineCodes: any = []) {
    let plCode = productLineCodes.length < 1 ? null : productLineCodes.join(',');
    return this.http.get<any>(`${environment.apiUrl}/v1/competitor-priority/getData?fileName=${fileName}&productLineCodes=${plCode}`);
  }

  getBrandTirelinesAllValues(productLineCodes: any = []) {
    let pl = productLineCodes.length < 1 ? null : productLineCodes.join(',');
    return this.http.post<any>(
      `${environment.apiUrl}/v1/brandsTirelinesAll?productLineCodes=${pl}`,
      {}
    );
  }
}
